import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import AssetLocationListLayer from "../components/AssetLocationListLayer";

const AssetLocationPage = () => {
  return (
    <>
      <MasterLayout pageTitle="Asset Locations">
        <AssetLocationListLayer />
      </MasterLayout>
    </>
  );
};

export default AssetLocationPage;
